<template>
  <BaseCard no-padding>
    <div class="tw:flex tw:flex-col tw:md:flex-row">
      <div
        class="tw:md:w-1/2 tw:bg-blue-300 tw:rounded-t-xl tw:md:rounded-l-xl tw:md:rounded-tr-none tw:flex tw:justify-center tw:items-center"
      >
        <img src="@/assets/img/rate-connect/rc-no-data.svg" alt="roomtypes" class="tw:w-[230px] tw:py-28" />
      </div>

      <div class="tw:md:w-1/2 tw:flex tw:justify-center tw:flex-col tw:py-8 tw:px-4 tw:md:py-0 tw:md:px-12">
        <h1 class="tw:text-2xl tw:xl:text-header-big tw:font-bold tw:pb-10">
          {{ $t('rc_opportunities_empty_state_header') }}
        </h1>
        <p class="tw:text-base tw:xl:text-xl">
          {{ $t('rc_opportunities_empty_state_info') }}
        </p>
      </div>
    </div>
  </BaseCard>
</template>
<script setup>
import BaseCard from '@/components/dashboard/BaseCard.vue'
</script>
